package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.data.repository.StatsRepository
import br.com.texeratx.boardgametimeapp.ui.screens.stats.StatsViewModel
import org.koin.dsl.module

val statsModule = module {
    single { StatsRepository(get(), get()) }
    factory { StatsViewModel(get()) }

}